import Immutable from 'seamless-immutable';
import _ from 'lodash';

import {
  SAVE_CUSTOM_TABLES,
  APPEND_CUSTOM_TABLES,
  SET_CUSTOM_TABLES_PAGINATION_DATA,
  SELECT_CUSTOM_TABLE,
  SET_CUSTOM_TABLES_FILTER,
  UPDATE_CUSTOM_TABLE,
  RESET_CUSTOM_TABLES_FILTERS,
  RESET_CUSTOM_TABLES_DATA,
  RESET_CUSTOM_TABLE_PAGINATION_DATA,
  SET_CUSTOM_TABLES_OPERATIONAL_MODE,
  ADD_FIELD_TO_TABLE,
  UPDATE_FIELD,
  DELETE_FIELD,
  SET_SELECTED_FIELD,
  SET_CUSTOM_TABLE_DATA,
  SET_CUSTOM_TABLE_ROWS,
  ADD_CUSTOM_TABLE_ROW,
  UPDATE_CUSTOM_TABLE_ROW,
  DELETE_CUSTOM_TABLE_ROW,
  SET_SELECTED_ROW,
  SET_CUSTOM_TABLE_ROWS_PAGINATION,
  RESET_CUSTOM_TABLE_ROWS_DATA,
  UPDATE_CUSTOM_TABLE_SNIPPET_ON_STATE,
  SAVE_CUSTOM_TABLE_LIMITS,
} from '../actions/actionTypes/customTables';
import { CUSTOM_SNIPPET_ENTITY_TYPES, CUSTOM_SNIPPET_EVENT_TYPES } from '../../_config/consts';

const initialState = Immutable({
  data: {
    content: [],
    pagination: {
      page: 0,
      pageSize: 50,
      totalElements: 0,
      totalPages: 0,
    },
    filters: {},
  },
  isOperationalMode: false,
  selectedCustomTable: {
    fields: [],
  },
  selectedField: null,
  customTableData: [],
  rows: {
    content: [],
    pagination: {
      page: 0,
      pageSize: 50,
      totalElements: 0,
      totalPages: 0,
    },
  },
  snippets: {
    content: [
      {
        name: 'Guest Access Notification',
        triggerType: 'entity', // 'time' or 'entity'
        minutes: 30, // only used when triggerType is 'time'
        entity: CUSTOM_SNIPPET_ENTITY_TYPES.GUESTS,
        event: CUSTOM_SNIPPET_EVENT_TYPES.CREATE,
        code: `// Example code that runs when a guest is createdconst guest = event.data;
      console.log('New guest created:', guest.name);
      // Add your custom logic here
      `
      }
    ],
    pagination: {
      page: 0,
      pageSize: 50,
      totalElements: 1,
      totalPages: 1,
    },
  },
  customTableLimits: null,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case SAVE_CUSTOM_TABLES:
      return state.setIn(['data', 'content'], action.customTables);
    case APPEND_CUSTOM_TABLES:
      return state.setIn(['data', 'content'], [...state.data.content, ...action.customTables]);
    case SET_CUSTOM_TABLES_PAGINATION_DATA:
      return state.setIn(['data', 'pagination'], action.pagination);
    case SELECT_CUSTOM_TABLE:
      return state.set('selectedCustomTable', action.customTable);
    case SET_CUSTOM_TABLES_OPERATIONAL_MODE:
      return state.set('isOperationalMode', action.value);
    case SET_CUSTOM_TABLES_FILTER:
      return state.setIn(['data', 'filters', action.field], action.value);
    case UPDATE_CUSTOM_TABLE: {
      const index = _.findIndex(state.data.content, data => data.id === action.customTable.id);
      if (index !== -1) {
        return state.setIn(['data', 'content', index], action.customTable);
      }
      return state;
    }
    case RESET_CUSTOM_TABLES_FILTERS:
      return state.setIn(['data', 'filters'], {});
    case RESET_CUSTOM_TABLES_DATA:
      return state.set('data', initialState.data);
    case RESET_CUSTOM_TABLE_PAGINATION_DATA:
      return state.setIn(['data', 'pagination'], {});
    case ADD_FIELD_TO_TABLE:
      return state.setIn(['selectedCustomTable', 'fields'], [...state.selectedCustomTable.fields, action.field]);
    case UPDATE_FIELD: {
      const fieldIndex = _.findIndex(state.selectedCustomTable.fields, field => field.id === action.field.id);
      if (fieldIndex !== -1) {
        return state.setIn(['selectedCustomTable', 'fields', fieldIndex], action.field);
      }
      return state;
    }
    case DELETE_FIELD: {
      const updatedFields = state.selectedCustomTable.fields.filter(field => field.id !== action.fieldId);
      return state.setIn(['selectedCustomTable', 'fields'], updatedFields);
    }
    case SET_SELECTED_FIELD:
      return state.set('selectedField', action.field);
    case SET_CUSTOM_TABLE_DATA:
      return state.set('customTableData', action.data);
    case SET_CUSTOM_TABLE_ROWS:
      return state.setIn(['rows', 'content'], action.rows);
    case ADD_CUSTOM_TABLE_ROW:
      return state.setIn(['rows', 'content'], [...state.rows.content, action.row]);
    case UPDATE_CUSTOM_TABLE_ROW:
      return state.setIn(['rows', 'content'], state.rows.content.map(row => 
        row.id === action.row.id ? action.row : row
      ));
    case DELETE_CUSTOM_TABLE_ROW:
      return state.setIn(['rows', 'content'], state.rows.content.filter(row => row.id !== action.rowId));
    case SET_SELECTED_ROW:
      return state.set('selectedRow', action.row);
    case SET_CUSTOM_TABLE_ROWS_PAGINATION:
      return state.setIn(['rows', 'pagination'], action.pagination);
    case RESET_CUSTOM_TABLE_ROWS_DATA:
      return state.set('rows', initialState.rows);
    case UPDATE_CUSTOM_TABLE_SNIPPET_ON_STATE:
      const index = _.findIndex(state.snippets.content, data => data.id === action.customTable.id);
      if (index !== -1) {
        return state.setIn(['snippets', 'content', index], action.customTable);
      }
      return state;
    case SAVE_CUSTOM_TABLE_LIMITS:
      return state.set('customTableLimits', action.limits);
    default:
      return state;
  }
} 